import "../../Projects/People/People.css";
import Hero from "../../Projects/People/Hero.jsx";
import AboutUs from "../../Projects/People/AboutUs.jsx";
import Vitrine from "../../Projects/People/Vitrine.jsx";
import Banner from "../../Projects/People/Banner.jsx";
import Story from "../../Projects/People/Story.jsx";
import Palette from "../../Projects/People/Palette.jsx";
import Images from "../../Projects/People/images.jsx";
import Footer from "../../general/Footer.jsx";

export default function People() {
  return (
    <div className="people-page">
      <Hero />
      <AboutUs />
      <Vitrine />
      <Banner />
      <Story />
      <Palette />
      <Images />
      <Footer />
    </div>
  );
}
